import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedUserDashboard = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'Admin' && user.role !== 'Super Admin') {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedUserDashboard;